<template>
    <!-- [CASE.1] normal groups -->
    <div class="ur-data-grid__content__group" v-if="data.group && isTarget">
        <div class="ur-data-grid__content__group-row" :class="rowClass" :style="rowStyle" v-if="gridInfo.opts.groupHeader">
            <span class="ur-data-grid__content__group-row__title" :style="titleStyle">{{convText}}</span>
            <span class="ur-data-grid__content__group-row__icon" @click="toggleHeader">
                <ur-icon>arrow_down</ur-icon>
            </span>
        </div>
        <template v-if="isExpand">
            <!-- [ZONE][CASE.1] Children :: Real data-row + partial -->
            <div class="ur-data-grid__content__group-row__child" v-if="data.leaf && isPartial"
                    :style="childWrapperStyle">
                <ur-data-grid-content-group-node v-for="(row,i) in rows" :data="row" :key="i"
                        :pos-start="posStart" :pos-end="posEnd" :group-height="nextHeight(i)" :freeze="freeze"/>
            </div>
            <!-- [ZONE][CASE.2] Children :: Real data-row + full -->
            <div class="ur-data-grid__content__group-row__child" v-else-if="data.leaf && !isPartial">
                <ur-data-grid-content-group-node v-for="(row,i) in rows" :data="row" :key="i"
                        :pos-start="posStart" :pos-end="posEnd" :group-height="nextHeight(i)" :freeze="freeze"/>
            </div>
            <!-- [ZONE][CASE.3] Children :: Child group -->
            <div class="ur-data-grid__content__group-row__child" v-else-if="!data.leaf">
                <ur-data-grid-content-group-node v-for="(ch,i) in data.children" :data="ch" :key="i"
                        :pos-start="posStart" :pos-end="posEnd" :group-height="nextHeight(i)" :freeze="freeze"/>
            </div>
            
            <!-- [ZONE] Group summary -->
            <template v-if="gridInfo.opts.groupSummary">
                <sum-frzz :group-node="data" v-if="freeze"/>
                <sum-cont :group-node="data" v-else/>
            </template>
        </template>
    </div>
    <!-- [CASE.2] Empty dummy -->
    <div class="ur-data-grid__content__group ur-data-grid__content__group--empty"
         v-else-if="data.group && !isTarget" :style="emptyStyle"/>
    <!-- [CASE.3] Data rows -->
    <div v-else class="ur-data-grid__content__group__row-wrapper">
        <row-frzz  :row="data" :group-height="groupHeight" :slide-accordion="isVertAcc" v-if="freeze"/>
        <row-cont  :row="data" :group-height="groupHeight" :slide-accordion="isVertAcc" v-else/>
        <accord-row :row="data" v-if="!gridInfo.opts.groupMerge && data.__accordion"/>
    </div>
</template>


<script>
import {dateToText} from '../../../util'
import rowCont   from '../../row/urDataGridContentRow.vue';
import rowFrzz   from '../../row/urDataGridContentFreezeRow.vue';
import sumCont   from '../../row/urDataGridContentGroupSummaryRow.vue';
import sumFrzz   from '../../row/urDataGridContentGroupSummaryFreeze.vue';
import accordRow from '../../row/urDataGridContentAccordionRow.js';
const INDENT_PX = 10;
import {copyObj} from '../../../util';

export default {
    name : 'urDataGridContentGroupNode',
    inject: ['gridInfo'],
    components : {rowCont, rowFrzz, accordRow, sumCont, sumFrzz},
    data() {return {
        rows : [],
        paddTop    : 0,
        wrapHeight : 0,
    }},
    props: {
        data        : {type:Object},
        posStart    : {type:Number},
        posEnd      : {type:Number},
        groupHeight : {type:Array},
        freeze      : {type:Boolean},
    },
    computed: {
        // [COMPUTED][FLAG] is freeze grid?
        isFreeze() {return !!this.gridInfo.vars_freezeWidth},
        // [COMPUTED][FLAG] is partial draw?
        isPartial() {return !!this.posStart || !!this.posEnd},
        // [COMPUTED][FLAG] is target for draw/show?
        isTarget()  {
            return !this.isPartial ||
                   (this.posEnd >= this.data.__st &&
                   this.data.__ed >= this.posStart);
                //&& !(this.posEnd < this.__st || this.__ed < this.posStart);
        },
        // [COMPUTED][FLAG] is Expanded?
        isExpand() {return this.data.expand},
        // [COPMUTED][DATA] group field
        myField() {
            var key = this.gridInfo.opts.grouping[this.data.depth]
            return this.gridInfo.fmap.get(key);
        },
        // [COPMUTED][DATA] Text(or title) for grouping
        convText() { // same as contentCell
            var f = this.myField,
                v = this.data.value;
            // 1. Custom value
            var cv = f.customValue;
            if(cv && typeof cv ==='function') {
                return cv(v);
            }
            // 2. Typed value
            switch(f.type) {
            case 'date':
                const fmt = f.dateFormat || this.gridInfo.opts.dateFormat;
                const timezone = f.timezone===null ? this.gridInfo.opts.timezone : f.timezone;
                return v?dateToText(v, fmt, timezone):''
            case 'code':
                if(f.__domainMap) {
                    var dobj = f.__domainMap.get(v);
                    return dobj?dobj.text:v;
                }
            }
            return v;
        },
        // [COMPUTED][STYLE] Row class
        rowClass() {
            var clazz = [];
            if(this.isExpand) {clazz.push('ur-data-grid__content__group-row--expand')}
            return clazz;
        },
        // [COMPUTED][STYLE] Row style
        rowStyle()   {return {'height':`${this.gridInfo.opts.groupRowHeight}px`}},
        // [COMPUTED][STYLE] Empty style -> Pseudo columns
        emptyStyle() {return {'height' : `${this.wrapHeight}px`}},
        // [COMPUTED][STYLE] Title style
        titleStyle() {return {'padding-left': `${10+this.data.depth*INDENT_PX}px`}},
        // [COMPUTED][STYLE] Children-wrapper style
        childWrapperStyle(){
            var gh = this.gridInfo.opts.groupHeader ? this.gridInfo.opts.groupRowHeight : 0;
            var sh = this.gridInfo.opts.groupSummary? this.gridInfo.opts.groupSummaryHeight: 0
            var style= {};
            style['height']      = (this.wrapHeight - gh - sh)+'px';
            style['padding-top'] = this.paddTop+'px';
            return style;
        },
        // [COMPUTED][WATCH] Watch trigger
        wTrigger() {
            return [this.posEnd, this.data.__ed, this.data.children];
        },
        isVertAcc() {return this.gridInfo.vars_accordionVert},
    },
    watch: {
        wTrigger() {
            this.buildRow();
        }
    },
    created() {
        this.buildRow();
    },
    methods : {
        toggleHeader() {
            this.data.expand = !this.data.expand;
            this.gridInfo.func.groupTreeOffset();
        },
        /* NOSONAR */buildRow() {
            // 0. prepare
            // 0.1 prepare data
            var data = this.data;
            this.wrapHeight = data.__ed - data.__st+1;
            // 0.2 check is leaf
            if(!data.group || !data.leaf) return;
            // 0.3 some variable
            var gh = this.gridInfo.opts.groupHeader ? this.gridInfo.opts.groupRowHeight : 0;
            // 1. get target array (&check empty)
            var dataArr = data.children;
            if(!dataArr||!dataArr.length) {
                this.rows = [];
                this.paddTop = 0;
                return; // ## RETURN build row
            }
            // 2. reset previous '__COMPO' attr
            //   if freeze -> freeze reset, scroll null
            if(this.isFreeze && this.freeze || !this.isFreeze) {
                dataArr.forEach(r => {// reset previous
                    var w = this.gridInfo.dataSet.getRow(r.__id)
                    if(!w) return;
                    w.__compo = null;
                });
            }
            // 3. copy from target
            if(this.isPartial) {
                // 3.1 is Partial view -> infinity scroll
                var rtn = [], offset = data.__st+gh,
                    ps = this.posStart, pe = this.posEnd,
                    rh = this.gridInfo.opts.rowHeight,
                    firstOffset = -1, cnt = 0;
                if(pe < data.__st || data.__ed < ps) {
                    this.rows = [];
                    this.paddTop = 0;
                    return; // ## RETURN build row
                }
                dataArr.find(row=>{cnt++;
                    var diff = rh + (!this.isVertAcc&&row.__accordion?row.__accordionHeight||0:0);
                    if(ps <= offset+diff && offset <=pe ){ // 겹치면 통과
                        firstOffset = firstOffset<0? (offset - data.__st - gh) : firstOffset;
                        rtn.push(row);
                    }
                    offset += diff;
                    return pe < offset
                })
                this.paddTop = firstOffset;
                this.rows = rtn.map(row => {
                    var clone;
                    row.__hover = false;
                    if(this.isFreeze && this.freeze || !this.isFreeze) {
                        clone = copyObj(row);
                        row.__compo = clone;
                    } else {
                        clone = row.__compo
                    }
                    return clone;
                }); // ## Logic END
            } else {
                // 3.2 or Full binding
                this.rows = dataArr.map(row => {
                    var clone;
                    if(this.isFreeze && this.freeze || !this.isFreeze) {
                        clone = copyObj(row);
                        row.__compo = clone;
                    } else {
                        clone = row.__compo
                    }
                    return clone
                }); // ## Logic END
            }
        },
        nextHeight(i) {
            var gh = this.gridInfo.opts.groupHeader ? this.gridInfo.opts.groupRowHeight : 0;
            var arr = [], h = i===0? this.data.__ed-this.data.__st-gh+1-this.paddTop : null;
            if(this.data.leaf && i!==0) return null;
            if(this.data.depth===0)     return [h]
            if(this.groupHeight)        return [...this.groupHeight, h]
            else return null;
        }
    }
}
</script>

